import { Grid, Typography } from "@mui/material";
import MainTitle from "../muiHome/mainTitle";
import React, { useState } from 'react';

import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel,
} from 'react-accessible-accordion';
import 'react-accessible-accordion/dist/fancy-example.css';




const SAHSResearch=()=>{

     
  const [selectedItem, setSelectedItem] = useState(null);

  const items = [
    { id: 1, title: 'Prof. Dr. Arun Garg', position: 'Vice Chancellor, MVN University', img:'/assets/img/placement/pro-1.jpg', desc: '<section> <p>Prof. Garg is a highly esteemed academician with over 37 years of distinguished experience in promoting excellence in pharmacy education. Before joining MVN University, he served as Professor and Dean at various pharmacy institutes and universities.</p><p>Throughout his illustrious career, Prof. Garg has made significant contributions to research in areas such as Drug Utilization Studies, Quality of Life Studies, Rational Use of Drugs, Hepatotoxicity, Liver Regeneration, Diabetes, Hypertension, and Cosmetics.</p><p>His groundbreaking research on Hepatotoxicity and Liver Regeneration was honored with the prestigious <strong>Dr. B. Mukherjee Award</strong> by the Indian Pharmacological Society for the best paper published in the Indian Journal of Pharmacology. In addition, he was awarded the <strong>Hamdard National Foundation Research Award</strong> for his innovative work on Cinkara.</p><p>Prof. Garg’s academic excellence was recognized early in his career when he secured the <strong>Gold Medal</strong> for attaining the first position in M. Pharmacology at his university. He is also a proud recipient of the <strong>Young Teacher Award</strong> conferred by the Society of Pharmaceutical Education and Research.</p><p>As Vice Chancellor of MVN University, Prof. Garg brings visionary leadership, a passion for research and innovation, and a steadfast commitment to nurturing academic excellence and holistic development among students.</p></section>' },
    { id: 2, title: 'Prof. (Dr.) S.H. Ansari', position: 'Emeritus Professor, School of Pharmaceutical Sciences MVN University' , img:'/assets/img/placement/pro-2.jpg', desc: '<section><p>Prof. Ansari brings with him an exceptional academic and leadership legacy, with over 37 years of teaching and research experience in the Department of Pharmacognosy and Phytochemistry at the Faculty of Pharmacy, Jamia Hamdard. He has also served with distinction as the Vice Chancellor of Jamia Hamdard University. He holds a Doctor of Science (D.Sc., h.c.) from the International University of Contemporary Studies, Washington, D.C., USA, and a Ph.D. in Pharmacognosy and Phytochemistry from Jamia Hamdard (1997). Additionally, he completed his M. Pharm. from Punjab University, Chandigarh (1981) and B. Pharm. from Delhi University (1979).</p><p>Prof. Ansari’s outstanding academic contributions are reflected in his impressive research metrics, with over 7148 citations, an h-index of 42, and an i10-index of 132.</p><p>His extensive experience, scholarly achievements, and visionary leadership are set to significantly enrich the academic environment at MVN University.</p></section>' },
    { id: 3, title: 'Prof. (Dr.) Yogendra Singh', position: 'Registrar, Dean Academics & Director of IQAC. MVN University, Palwal' , img:'/assets/img/placement/pro-3.jpg', desc: '<section> <p>Prof. (Dr.) Yogendra Singh is a distinguished academic leader and expert in pharmaceutical sciences, bringing over 22 years of rich experience spanning academia and the pharmaceutical industry. He currently serves as the Registrar, Dean Academics and Director of IQAC at MVN University, Palwal.</p><p>Throughout his career, Dr. Singh has held key leadership positions at reputed institutions at different pharmacy institutions and universities. He possesses extensive expertise in university-level accreditation systems, quality assurance processes, research, and teaching methodologies.</p><p>With a strong commitment to academic excellence and institutional development, Dr. Singh continues to drive innovation, foster quality education, and contribute significantly to the growth and reputation of MVN University.</p></section>' },
    { id: 4, title: 'Prof. (Dr.) Ashutosh Upadhayay', position: 'Professor & Dean, MVN University, Palwal, Haryana' , img:'/assets/img/placement/pro-4.jpg', desc: '<section><p>Dr. Ashutosh Upadhayay, a distinguished academician and researcher in the field of Pharmacology, currently serves as Professor and Dean at MVN University, Palwal, Haryana. With over 20 years of experience in pharmacy education and research, Dr. Upadhayay has made significant contributions to clinical research, toxicology, and drug development, particularly in antidiabetic and anti-hyperlipidemic therapies.</p><p>He has authored over 50 research papers published in reputed international and national journals and has guided numerous M.Pharm and Ph.D. research scholars. His recent research includes clinical trials methodology, phytoconstituent-based therapies, asthma management, and toxicological studies, with publications in journals like European Chemical Bulletin, Infectious Disorders - Drug Targets, and Anti-inflammatory & Anti-allergy Agents in Medicinal Chemistry.</p><p>Dr. Upadhayay is also an accomplished author with multiple textbooks and practical guides in the field of pharmacy and has been granted a patent for a polyherbal formulation for wound healing. His active involvement in organizing national and international conferences and workshops highlights his commitment to advancing pharmaceutical education and research.</p><p>He holds a Ph.D. in Pharmacology from NIMS University, Rajasthan, and is a life member of professional bodies including APTI and IPGA. Dr. Upadhayay’s contributions have been recognized with several prestigious awards, including the Best Teacher Award (2014, 2022) and the Best Researcher Award (2023).</p></section>' },
    { id: 5, title: 'Dr. Jayamanti Pandit', position: 'Ph.D. (Pharmaceutics) | Researcher in Drug Delivery Systems | Patent Agent' , img:'/assets/img/placement/pro-5.jpg', desc: '<p>Dr. Jayamanti Pandit is a distinguished researcher in the field of Pharmaceutics, with a research career spanning over 15 years, marked by innovation and excellence in advanced drug delivery systems. Her primary research interests include the development of vesicular, particulate, and nanofiber-based drug carriers, with a specialized focus on ocular and transdermal drug delivery, and pharmacokinetics of novel dosage forms.</p><p>She has authored 32 high-impact publications, including peer-reviewed journal articles and book chapters, contributing significantly to the advancement of pharmaceutical sciences. Her dedication to impactful research has earned her several prestigious fellowships and recognitions:</p><ul><li>Indian Council of Medical Research (ICMR) Research Associate Fellowship (2020)</li><li>CSIR-Senior Research Fellowship during her Ph.D. at Jamia Hamdard University</li><li>UGC-Junior Research Fellowship during her M. Pharm at Dr. H.S. Gour University</li><li>Certificates of Appreciation from Jamia Hamdard for outstanding publications (2018 & 2022)</li></ul><p>In addition to her pharmaceutical expertise, Dr. Jayamanti Pandit is a qualified Patent Agent, having cleared the national examination in her first attempt in 2022. She also received the Women Scientist Scholarship (WOS-C, KIRAN IPR) under the Department of Science and Technology (DST), Government of India, highlighting her contributions at the intersection of pharmaceutics and intellectual property.</p><p>Dr. Jayamanti Pandit continues to contribute to cutting-edge research, mentoring young scholars and driving innovation in drug delivery technologies.</p>' },
    { id: 6, title: 'Dr. Geeta Mahlawat', position: 'Associate Professor, School of Pharmaceutical Sciences MVN University, Palwal' , img:'/assets/img/placement/pro-6.jpg', desc: '<p>Dr. Geeta Mahlawat holds a Ph.D. in Pharmaceutics from MVN University, Palwal. Her research focuses on drug formulation and development, with  specialization  in the in vitro release profiling of pharmaceuticals, particularly Timolol Maleate. She has authored multiple research and review articles on topics including fast-dissolving drug delivery systems, ophthalmic gel formulations, and the role of pharmacists in healthcare.</p><p>Dr. Mahlawat has presented her research at several national and international conferences and has been recognized with awards such as the Best Dedicated Faculty Award. Her active participation in faculty development programs and her commitment to innovation in pharmaceutical sciences continue to strengthen academic and research excellence at MVN University.</p>' },
    
  ];

  const handleItemClick = (item) => {
    setSelectedItem(item);
  };

  const closePopup = () => {
    setSelectedItem(null);
  };




return (
<Grid container spacing={2}>
<Grid item xs={12}>
    <MainTitle title="School of Pharmaceutical Sciences" />
    </Grid>

    <Grid item xs={12}>
    <MainTitle title="Research & Development" />
    </Grid>

    <Grid item xs={12} textAlign='justify'>
        <p>Research has always been a cornerstone of higher education at MVN University, fostering innovation and intellectual growth since its inception. The University’s Research & Development Cell offers a dynamic and enriching environment that encourages students and faculty to engage in meaningful research activities. With a strong focus on nurturing a research-oriented mindset and cultivating leadership qualities, the cell actively supports various scholarly pursuits—including fundamental research, applied investigations, and collaborative projects with government, private, and international organizations.</p>
        <p>Over time, MVN University has significantly broadened its research footprint, taking on sponsored projects and consultancy work across diverse fields such as Pharmacy, Science, Engineering, Technology and Management.</p>
        <p>The University continues to expand its research vision by onboarding talented researchers, refining policies to strengthen infrastructure and forging strategic collaborations with academic and industry partners. These partnerships, along with the active involvement of research teams, contribute to a vibrant ecosystem where ideas are exchanged, resources are shared and cutting-edge research is brought to life.</p>
        <div className="objectives">
            <h4>Research Objectives at MVN University</h4>
            <ul>
                <li>To cultivate a strong and sustainable research culture across all academic disciplines.</li>
                <li>To foster leadership and innovation through active student and faculty engagement in research.</li>
                <li>To support and promote all forms of scholarly activities including basic, applied and contract research.</li>
                <li>To expand sponsored research and consultancy projects in key domains like Science, Technology, Pharmacy and Management.</li>
                <li>To improve research infrastructure through strategic policies and funding.</li>
                <li>To encourage collaborative research with national and international institutions.</li>
                <li>To facilitate knowledge-sharing and resource pooling through academic and industry partnerships.</li>
                <li>To continuously welcome and engage with external stakeholders to drive impactful and socially relevant research.</li>
                <li>To Provide Research promotion incentives, to encourage research among the faculty member and researcher. </li>
            </ul>
        </div>
    </Grid>

 

      {selectedItem && (
        <div style={popupOverlayStyle} className="profile_popup">
          <div style={popupStyle} className="profile_container">
             <button onClick={closePopup}>Close</button>
                <div className="popupfile">
                    <div className="row">
                        <div className="col-md-3">
                            <div className="profile_image">
                                <img src={selectedItem.img} />

                            </div>
                        </div>
                        <div className="col-md-9">
                             <div className="profile_details">
                                    <h2>{selectedItem.title}</h2>
                                    <h5> {selectedItem.position} </h5>
                                    <div className="profile_description"  dangerouslySetInnerHTML={{ __html: selectedItem.desc }} />
                             </div>

                        </div>
                    </div>

                </div>

         
           
          </div>
        </div>
      )} 


    
    <div className="highlightsmvnu">
        <h4>Highlights Of MVN University: </h4>
        
        <div className="container">
            <div className="row">
                {items.map((item) => (
                    

                    <div className="col-md-4 col-sm-4 col-xs-12" key={item.id} onClick={() => handleItemClick(item)} style={{ cursor: 'pointer' }}>
                        <div className="profile">
                            <img src={item.img} alt="img"/>
                            <label> {item.title}</label>
                            <p>{item.position}</p>
                        </div>
                    </div>

                    
                    ))}

                    
                  
            </div>
        </div>
    </div>
    <div className="research-data">
        <div className="container">
            <div className="row">
                <div className="col-md-12">
                    <Accordion>
                        <AccordionItem>
                            <AccordionItemHeading>
                                <AccordionItemButton>
                                Research Paper in a conference
                                </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel>
                            
                                <div className="tabele">
                                    <h4>Coming Soon</h4>
                                    
                                </div>
                            </AccordionItemPanel>
                        </AccordionItem>
                        <AccordionItem>
                            <AccordionItemHeading>
                                <AccordionItemButton>
                                Research Publications
                                </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel>

                                <div className="tabele">
                                <h4>Latest Research Publications (2024-2025)</h4>
                                <table>
                                    <thead>
                                        <tr>
                                            <th>Author</th>
                                            <th>Title</th>
                                            <th>Journal</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Dr. Ashutosh Upadhayay</td>
                                            <td>Antidiabetic and in vivo antioxidant activity of ethanolic extract of Geniosporumprostratum aerial parts on STZ induced diabetic rats</td>
                                            <td>Scholars Research Library Der Pharmacia Lettre</td>
                                        </tr>
                                        <tr>
                                            <td>Dr. Jayamanti Pandit</td>
                                            <td>Beeswax-based nanoconstructs enriched dual responsive hydrogel for diabetic foot ulcers in streptozotocin-induced diabetic rats</td>
                                            <td>International Journal of Biological Macromolecules</td>
                                        </tr>
                                        <tr>
                                            <td>Dr. Geeta Mehlawat</td>
                                            <td>Implementation Of Box Behnken Design To Fabricate The Formulation, Optimization And Dissolution Of Blueberry Nanosuspension</td>
                                            <td>Journal of Pharmaceutical Negative Results</td>
                                        </tr>
                                        <tr>
                                            <td>Dr. Yogendra Singh</td>
                                            <td>Effect of combination of renin inhibitor and Mas-receptor agonist in DOCA–salt-induced hypertension in rats</td>
                                            <td>Molecular and cellular biochemistry</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            
                            </AccordionItemPanel>
                        </AccordionItem>
                        <AccordionItem>
                            <AccordionItemHeading>
                                <AccordionItemButton>
                                Review Articles
                                </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel>

                                
                                <div className="tabele">
                                    <h4>Latest Review Article (2024-2025)</h4>
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>Author</th>
                                                <th>Title</th>
                                                <th>Journal</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Dr. Yogendra Singh</td>
                                                <td>Phytochemical Study And In Vitro Anti-Diabetic Activity Of Eucalyptus And Lemon Oils</td>
                                                <td>European Chemical Bulletin</td>
                                            </tr>
                                            <tr>
                                                <td>Dr. Jayamanti Pandit</td>
                                                <td>Role of polyphenols, their nano-formulations, and biomaterials in diabetic wound healing</td>
                                                <td>Endocrine, Metabolic & Immune Disorders-Drug Targets</td>
                                            </tr>
                                            <tr>
                                                <td>Dr. Ashutosh Upadhayay</td>
                                                <td>A review on comparison of allopathic medicines to other drug therapies in the management of asthama.</td>
                                                <td>Infect Disord Drug targets</td>
                                            </tr>
                                            <tr>
                                                <td>Pushpika Jain </td>
                                                <td>Enhancing therapy with nanobased delivery system colon exploring the bioactive properties and effect of apigenin</td>
                                                <td>Therapeutic Delivery</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                
                            </AccordionItemPanel>
                        </AccordionItem>
                        <AccordionItem>
                            <AccordionItemHeading>
                                <AccordionItemButton>
                                Patents
                                </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel>

                                
                            <div className="tabele">
                                <h4>Latest Patents (2024-2025)</h4>
                                <table>
                                    <thead>
                                        <tr>
                                            <th>Author</th>
                                            <th>Title</th>
                                            <th>Patent Number</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Dr. Yogendra Singh</td>
                                            <td>Incubator for Controlling Temperature and Humidity for the Cultivation and Propagation of Plant Cell Cultures</td>
                                            <td>389630-001- India Design Patent</td>
                                        </tr>
                                        <tr>
                                            <td>Ms. Shivali Rahi</td>
                                            <td>AI-enabled device for early detection of Cardiac Diseases</td>
                                            <td>6319794- UK Design Patent</td>
                                        </tr>
                                        <tr>
                                            <td>Ms. Neha Dagar</td>
                                            <td>Transferrin- Decprated Chitosan- EC nanoparticles for Controlled & Targeted Delivery of Myricetin for Diabetes Mellitus</td>
                                            <td>202311051960- India Design Patent</td>
                                        </tr>
                                        <tr>
                                            <td>Mr. Joyson Paul</td>
                                            <td>Wrist Band For Monitoring And Treatment Of Epilepsy</td>
                                            <td>416375-001 -Indian Design Patent</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            </AccordionItemPanel>
                        </AccordionItem>
                        <AccordionItem>
                            <AccordionItemHeading>
                                <AccordionItemButton>
                                Book Chapters
                                </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel>

                                
                            
                                <div className="tabele">
                                    <h4>Latest Book Chapters (2024-2025)</h4>
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>Author</th>
                                                <th>Title</th>
                                                <th>Book Title</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Dr. Yogendra Singh</td>
                                                <td>The Chemistry and Pharmacological Study of Capaifera spp. Oils</td>
                                                <td>The Chemistry Inside Spices & Herbs</td>
                                            </tr>
                                            <tr>
                                                <td>Dr. Jayamanti Pandit</td>
                                                <td>Application of MNPs in Targeted Delivery and Genetic Manipulations</td>
                                                <td>Metallic Nanoparticles for Health and the Environment</td>
                                            </tr>
                                            <tr>
                                                <td>Mansi Gaba</td>
                                                <td>Nanotherapeutics in Malaria</td>
                                                <td>Applications of Nanotherapeutics and nanotheranostics in managing infectious diseases</td>
                                            </tr>
                                            <tr>
                                                <td>Neha Dagar</td>
                                                <td>Role of carbohydrates in drug delivery</td>
                                                <td>Carbohydrates in chemistry and biology</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                
                            </AccordionItemPanel>
                        </AccordionItem>
                        <AccordionItem>
                            <AccordionItemHeading>
                                <AccordionItemButton>
                                Books
                                </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel>

                                
                                <div className="tabele">
                                    <h4>Latest Books (2024-2025)</h4>
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>Author</th>
                                                <th>Title</th>
                                                <th>Publisher</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Dr. Yogendra Singh</td>
                                                <td>A Comprehensive Book of Pharmacy</td>
                                                <td>Corvette Press</td>
                                            </tr>
                                            <tr>
                                                <td>Dr. Ashutosh Upadhayay</td>
                                                <td>A Text book of Pharmaceutical Jurisprudence</td>
                                                <td>Nitya Publication, Bhopal, MP, India</td>
                                            </tr>
                                            <tr>
                                                <td>Rajkiran</td>
                                                <td>Human Anatomy and Physiology: A Practical Notebook for First Year Diploma in Pharmacy</td>
                                                <td>AkiNik Publications</td>
                                            </tr>
                                            <tr>
                                                <td>Dr. Ashutosh Upadhayay</td>
                                                <td>A practical book of Pharmacology- II</td>
                                                <td>Gurugram, Haryana, India.</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                
                            </AccordionItemPanel>
                        </AccordionItem>
                    </Accordion>
                </div>
            </div>
        </div>
    </div>
    </Grid>
    

)
}


// Popup styles
const popupOverlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100vw',
  height: '100vh',
  backgroundColor: 'rgba(0,0,0,0.4)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 9999
};

const popupStyle = {
  background: '#fff',
  padding: '20px',
  borderRadius: '8px',
  minWidth: '300px',
  width: '70%',
  maxHeight: '80vh',
  overflow: 'auto'

};



export default SAHSResearch;